import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { RHFCheckboxField } from '@openx/components-core/lib/CheckboxField/RHFCheckboxField';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { TargetingFields } from '@openx/types/targeting/targeting';
import { noop } from '@openx/utils/noop';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

const StyledGridCheckbox = styled(Grid)`
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  padding-left: ${({ theme }) => theme.spacing(0.5)};
`;

type ExcludeMFAProps = {
  excludeMFAValue: boolean;
  onFieldUpdate?: (newData: boolean) => void;
  readonly?: boolean;
};

export const ExcludeMFA = ({
  excludeMFAValue,
  onFieldUpdate = noop,
  readonly,
}: ExcludeMFAProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (readonly) {
    return excludeMFAValue ? (
      <FieldDetails title={t('Exclude MFA Inventory')} checkbox value={excludeMFAValue} />
    ) : null;
  }

  return (
    <StyledGridCheckbox sx={{ display: 'block' }} size={12}>
      <RHFCheckboxField
        name={`targeting.${TargetingFields.METACATEGORY}.${TargetingFields.EXCLUDE_MFA}`}
        label={t('Exclude MFA Inventory')}
        onChange={event => {
          event.preventDefault();
          onFieldUpdate(!excludeMFAValue);
        }}
        data-test="exclude-mfa-inventory"
      />
    </StyledGridCheckbox>
  );
};
